import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

type GameSettings = {
  isShowPositions: boolean;
  isMuted: boolean;
  setIsShowPositions: (show: boolean) => void;
  setIsMuted: (muted: boolean) => void;
};

export const useSettingsStore = create<GameSettings>()(
  immer((set) => ({
    isShowPositions: true,
    isMuted: true,
    setIsShowPositions: (show) =>
      set((state) => {
        state.isShowPositions = show;
      }),
    setIsMuted: (muted) =>
      set((state) => {
        state.isMuted = muted;
      }),
  }))
);
